/* eslint-disable react/no-array-index-key */

/* eslint-disable @typescript-eslint/no-explicit-any */
import bcrypt from 'bcryptjs';
import React from 'react';

export function debounce<F extends (...args: Parameters<F>) => ReturnType<F>>(
  func: F,
  waitFor: number,
): (...args: Parameters<F>) => void {
  let timeout: NodeJS.Timeout;
  return (...args: Parameters<F>): void => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func(...args), waitFor);
  };
}

export function isEmpty(value: string) {
  return value.trim() === '';
}

export function isValidEmail(email: string) {
  const regex =
    /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i;

  return !!(email && regex.test(email));
}

export function isValidPassword(password: string) {
  // TODO: Change if needed
  return !!(password.trim().length >= 8);
}

export function slugify(str: string) {
  return str
    .toString()
    .normalize('NFKD')
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '-')
    .replace(/[^\w-]+/g, '')
    .replace(/_/g, '-')
    .replace(/--+/g, '-')
    .replace(/-$/g, '');
}

export function buildParams(data: object) {
  const params = new URLSearchParams();

  Object.entries(data).forEach(([key, value]) => {
    if (!value) return;
    if (Array.isArray(value)) {
      value.forEach((el) => params.append(key, el.toString()));
    } else {
      params.append(key, value.toString());
    }
  });

  return params.toString();
}

export function range(start: number, end: number) {
  const length = end - start + 1;
  return Array.from({ length }, (_, idx) => idx + start);
}

export const ToBool = (str?: string): boolean => {
  if (str === undefined) str = '';
  str = str.toString();
  switch (str.toLowerCase()) {
    case 'false':
    case 'no':
    case '0':
    case '': {
      return false;
    }

    default: {
      return true;
    }
  }
};

export function mailTo(email: string, subject?: string, body?: string) {
  let url;
  url = `mailto:${email}`;
  if (subject) url += `?subject=${subject}`;
  if (body) url += `&body=${body}`;
  window.open(url);
}

export function chunkIntoN(arr: any[], n: number) {
  const result = [];
  for (let i = n; i > 0; i -= 1) {
    result.push(arr.splice(0, Math.ceil(arr.length / i)));
  }
  return result;
}

export function hasRoom(
  container: HTMLButtonElement | null,
  element: HTMLDivElement | null,
  center?: boolean,
) {
  const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);

  return (
    vw >
    (container?.getBoundingClientRect().left || 0) +
      (center ? (container?.offsetWidth || 0) / 2 : 0) +
      (element?.offsetWidth || 0) / (center ? 2 : 1) +
      24
  );
}

export function shuffle(array: any) {
  let m = array.length;
  let t;
  let i;

  // While there remain elements to shuffle…
  while (m) {
    // Pick a remaining element…
    i = Math.floor(Math.random() * (m -= 1));

    // And swap it with the current element.
    t = array[m];
    array[m] = array[i];
    array[i] = t;
  }

  return array;
}

export function capitalize(string: string): string {
  if (!string) return '';
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function isJsonString(str: string) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}

export const convertToNewLine = (children: any): any => {
  if (Array.isArray(children)) {
    return children.map((el) => convertToNewLine(el));
  }
  if (typeof children === 'string') {
    return children.split(/\\n|\n/g).map((line, i, arr) => (
      <React.Fragment key={i}>
        {line}
        {i !== arr.length - 1 && <br />}
      </React.Fragment>
    ));
  }
  if (children?.props?.children) {
    const newChildren = React.Children.map(children.props.children, (child) =>
      convertToNewLine(child),
    );
    return React.cloneElement(children, { children: newChildren });
  }

  return children;
};

export const hashPassword = async (password: string): Promise<string> => {
  const salt = '$2b$12$1p9i99gYFTKC0tw85Ys5Re';
  const hashedPassword = await bcrypt.hash(password, salt);
  return hashedPassword;
};

export const getLocalStorageItem = (key: string): string | null => {
  const item = window.localStorage.getItem(key);
  return item;
};

export const setLocalStorageItem = (key: string, value: string): void => {
  window.localStorage.setItem(key, value);
};
